import { render, staticRenderFns } from "./MajorAccident.vue?vue&type=template&id=46a568c6&scoped=true"
import script from "./MajorAccident.vue?vue&type=script&lang=js"
export * from "./MajorAccident.vue?vue&type=script&lang=js"
import style0 from "./MajorAccident.vue?vue&type=style&index=0&id=46a568c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a568c6",
  null
  
)

export default component.exports